import { Box, Breadcrumbs as MuiBreadcrumbs, Skeleton, Typography, useTheme } from '@mui/material';

import { RouterLink } from '~components';
import VectorImage from '~components/media/vectorImage';
import { pagePathSegments } from '~constants';
import { Crumb } from '~layouts/interfaces/crumb';
import { Dimens } from '~themes';

interface Props {
	isLoading: boolean;
	crumbs: Crumb[];
	preservedBreadcrumbSearch?: string;
}

const Breadcrumbs = ({ isLoading, crumbs, preservedBreadcrumbSearch }: Props) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'flex-end',
			}}
		>
			{isLoading ?
				<Skeleton height={Dimens.fixed(28.5)} width={Dimens.fixed(200)} />
			:	<MuiBreadcrumbs
					separator={<VectorImage name='chevron/right' size={Dimens.spacingXl} />}
					sx={{
						'& .MuiBreadcrumbs-separator': { mx: Dimens.spacingMd },
					}}
				>
					<RouterLink
						to={pagePathSegments.Home}
						color={theme.palette.textQuaternary.main}
						underline='hover'
					>
						<VectorImage
							name='icon/home-line'
							size={Dimens.spacingXl}
							style={{ marginTop: Dimens.spacingSm }}
						/>
					</RouterLink>
					{crumbs.map((crumb, i) =>
						i < crumbs.length - 1 ?
							<RouterLink
								key={`${crumb.path}-${i}`}
								to={{
									pathname: crumb.path,
									search: preservedBreadcrumbSearch,
								}}
								variant='labelSm'
								underline='hover'
								color={theme.palette.textQuaternary.main}
							>
								{crumb.title}
							</RouterLink>
						:	<Typography
								key={`${crumb.path}-${i}`}
								variant='labelSm'
								color={theme.palette.textPrimary.main}
							>
								{crumb.title}
							</Typography>
					)}
				</MuiBreadcrumbs>
			}
		</Box>
	);
};

export default Breadcrumbs;
